module.exports = __webpack_public_path__ + "img/hagongda.8b169c03.png";